'use es6';

import { OrderedSet } from 'immutable';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/Submissions';
import * as FormSubmissionsTableActions from 'FormsUI/actions/FormSubmissionsTable';
import { REQUEST_SUBMISSION_BOOTSTRAP_SUCCESS } from 'FormsUI/actions/CustomObjects';
import { Columns, DEFAULT_NON_REMOVABLE_COLUMNS, RESERVED_COLUMN_NAMES } from 'FormsUI/constants/Submissions';
const INIT_STATE = {
  pageNumber: 1,
  requiredColumns: new OrderedSet([Columns.CONTACTS]),
  abmSubmissions: {},
  submissionsInitalValues: {},
  formSubmissionsTable: []
};
const getRequiredColumns = ({
  results
}) => new OrderedSet(results.flatMap(({
  values
}) => Object.keys(values)).filter((v, i, a) => a.indexOf(v) === i).filter(value => DEFAULT_NON_REMOVABLE_COLUMNS.includes(RESERVED_COLUMN_NAMES[value])).map(value => RESERVED_COLUMN_NAMES[value]));
export function submissions(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.UPDATE_SUBMISSIONS_PAGE_NUMBER:
      return Object.assign({}, state, {
        pageNumber: action.number
      });
    case Actions.REQUEST_ABM_FORM_SUBMISSION:
      return Object.assign({}, state, {
        abmSubmissions: Object.assign({}, state.abmSubmissions, {
          [action.conversionId]: {
            requestState: RequestState.REQUESTED,
            submission: {}
          }
        })
      });
    case Actions.REQUEST_ABM_FORM_SUBMISSION_SUCCESS:
      return Object.assign({}, state, {
        abmSubmissions: Object.assign({}, state.abmSubmissions, {
          [action.conversionId]: {
            requestState: RequestState.SUCCEEDED,
            submission: action.submission
          }
        })
      });
    case Actions.REQUEST_ABM_FORM_SUBMISSION_FAIL:
      {
        return Object.assign({}, state, {
          abmSubmissions: Object.assign({}, state.abmSubmissions, {
            [action.conversionId.toString()]: {
              requestState: RequestState.FAILED,
              submission: []
            }
          })
        });
      }
    case FormSubmissionsTableActions.REQUEST_FORM_SUBMISSIONS_TABLE:
      {
        return Object.assign({}, state, {
          formSubmissionsTable: Object.assign({}, state.formSubmissionsTable, {
            [JSON.stringify(action.query)]: {
              requestState: RequestState.REQUESTED
            }
          })
        });
      }
    case FormSubmissionsTableActions.REQUEST_FORM_SUBMISSIONS_TABLE_FAIL:
      {
        return Object.assign({}, state, {
          formSubmissionsTable: Object.assign({}, state.formSubmissionsTable, {
            [JSON.stringify(action.query)]: {
              requestState: RequestState.FAILED,
              results: [],
              offset: 0,
              total: 0
            }
          })
        });
      }
    case FormSubmissionsTableActions.REQUEST_FORM_SUBMISSIONS_TABLE_SUCCESS:
      {
        return Object.assign({}, state, {
          requiredColumns: getRequiredColumns(action.payload),
          formSubmissionsTable: Object.assign({}, state.formSubmissionsTable, {
            [JSON.stringify(action.query)]: Object.assign({
              requestState: RequestState.SUCCEEDED
            }, action.payload)
          })
        });
      }
    case REQUEST_SUBMISSION_BOOTSTRAP_SUCCESS:
      {
        return Object.assign({}, state, {
          submissionsInitalValues: {
            [action.formGuid]: {
              mostRecentSubmissionTimestamp: action.payload.mostRecentSubmissionTimestamp
            }
          }
        });
      }
    default:
      return state;
  }
}